import axiosInstance from '../common/axios';

const backendUrl = process.env.REACT_APP_BACKEND_URL;

export async function saveOrder(data) {
  return axiosInstance.post(`${backendUrl}/api/orders`, data);
}


export async function payOrder(data) {
//  return axiosInstance.post(`${backendUrl}/api/orders/pay`, data);
  
  return axiosInstance.post(`${backendUrl}/api/payments/pay`, data);
  
}



export async function getUserOrder(userId, pageToLoad,PAGE_SIZE ) {
  return await axiosInstance.get(`${backendUrl}/api/orders/user/${userId}`, {
     params: {
                    page: pageToLoad,
                    size: PAGE_SIZE
                }
  });
}



export default { saveOrder , payOrder, getUserOrder };